import { render, staticRenderFns } from "./ScheduleDay.vue?vue&type=template&id=488f4c9d&scoped=true&"
import script from "./ScheduleDay.vue?vue&type=script&lang=js&"
export * from "./ScheduleDay.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDay.vue?vue&type=style&index=0&id=488f4c9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f4c9d",
  null
  
)

export default component.exports